module.exports = "/_next/static/images/img_friends-5fc6a410e961048809238ddee1a5538f.svg";